module.exports = __webpack_public_path__ + "img/adhyapana_plus_product_img.dcefa56d.jpg";